@if (isTracking()) {
    <div
        class="tracking-banner" 
        (click)="openTrackingMap()">
        <div class="tracking-content">
        <div class="pulse-animation"></div>
        <ion-text>Ortung aktiv</ion-text>
        <ion-button fill="clear" size="small">
            <ion-icon name="map-outline" slot="icon-only"></ion-icon>
        </ion-button>
        </div>
    </div>
}